import React, { useEffect, useRef } from 'react';

function LandingPage() {
  const fenceRef = useRef(null);

  useEffect(() => {
    if (fenceRef.current) {
      const container = fenceRef.current;
      const numPosts = Math.ceil(window.innerWidth / 30);
      for (let i = 0; i < numPosts; i++) {
        const post = document.createElement('div');
        post.style.cssText = `width:12px; background:#8B5E3C; margin:0 8px; border-radius:2px 2px 0 0; flex-shrink:0; height:${60 + Math.random() * 60}px`;
        container.appendChild(post);
      }
    }
  }, []);

  const styles = {
    root: { fontFamily: '"DM Sans", -apple-system, BlinkMacSystemFont, sans-serif', background: '#f5f0e8', color: '#1c1c1c', overflowX: 'hidden' },
    nav: { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 60px', background: 'rgba(26,58,42,0.97)', backdropFilter: 'blur(10px)' },
    navLogo: { fontFamily: '"Bebas Neue", sans-serif', fontSize: '28px', color: '#c8e86a', letterSpacing: '2px' },
    navCta: { background: '#c8e86a', color: '#1a3a2a', padding: '12px 28px', borderRadius: '4px', fontWeight: 600, fontSize: '15px', textDecoration: 'none', transition: 'all 0.2s', display: 'inline-block' },
    hero: { minHeight: '100vh', background: '#1a3a2a', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', padding: '120px 60px 80px' },
    heroBadge: { display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(200,232,106,0.15)', border: '1px solid rgba(200,232,106,0.3)', color: '#c8e86a', padding: '8px 16px', borderRadius: '100px', fontSize: '13px', fontWeight: 500, marginBottom: '30px' },
    h1: { fontFamily: '"Bebas Neue", sans-serif', fontSize: 'clamp(64px, 8vw, 110px)', lineHeight: 0.95, color: 'white', letterSpacing: '1px', marginBottom: '24px' },
    accent: { color: '#c8e86a', display: 'block' },
    heroSub: { fontSize: '20px', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, maxWidth: '520px', marginBottom: '40px', fontWeight: 300 },
    btnPrimary: { background: '#c8e86a', color: '#1a3a2a', padding: '18px 40px', borderRadius: '4px', fontWeight: 700, fontSize: '17px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px', marginRight: '16px' },
    btnSecondary: { background: 'transparent', color: 'white', padding: '18px 40px', borderRadius: '4px', fontWeight: 500, fontSize: '17px', textDecoration: 'none', border: '1.5px solid rgba(255,255,255,0.3)', display: 'inline-block' },
    heroStats: { position: 'absolute', right: '60px', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', gap: '20px' },
    statCard: { background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px', padding: '24px 30px', textAlign: 'center', backdropFilter: 'blur(10px)', minWidth: '160px' },
    statNumber: { fontFamily: '"Bebas Neue", sans-serif', fontSize: '52px', color: '#c8e86a', lineHeight: 1 },
    statLabel: { fontSize: '13px', color: 'rgba(255,255,255,0.6)', marginTop: '4px' },
    fenceGraphic: { position: 'absolute', bottom: 0, left: 0, right: 0, height: '120px', display: 'flex', alignItems: 'flex-end', overflow: 'hidden', opacity: 0.15 },
    section: { padding: '100px 60px', maxWidth: '1200px', margin: '0 auto' },
    sectionLabel: { fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '3px', color: '#4a7c59', marginBottom: '16px' },
    sectionTitle: { fontFamily: '"Georgia", serif', fontStyle: 'italic', fontSize: 'clamp(36px, 4vw, 54px)', lineHeight: 1.15, color: '#1a3a2a', marginBottom: '20px' },
    painGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '50px' },
    painCard: { background: 'white', borderRadius: '12px', padding: '30px', borderLeft: '4px solid #c0392b', boxShadow: '0 2px 20px rgba(0,0,0,0.05)' },
    featureGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '40px' },
    featureCard: { background: 'white', borderRadius: '14px', padding: '28px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', borderTop: '4px solid #1a3a2a' },
    stepsGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '40px', marginTop: '60px' },
    stepNumber: { width: '80px', height: '80px', background: '#1a3a2a', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '"Bebas Neue", sans-serif', fontSize: '36px', color: '#c8e86a', margin: '0 auto 24px' },
    testimonialsSection: { background: '#1a3a2a', padding: '100px 60px' },
    testimonialGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', marginTop: '50px', maxWidth: '1100px', margin: '50px auto 0' },
    testimonialCard: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '30px' },
    faqSection: { padding: '100px 60px', background: 'white' },
    faqItem: { borderBottom: '1px solid #eee', padding: '24px 0' },
    finalCta: { padding: '120px 60px', background: '#c8e86a', textAlign: 'center', position: 'relative', overflow: 'hidden' },
    footer: { background: '#1c1c1c', padding: '40px 60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' },
  };

  return (
    <div style={styles.root}>
      {/* Google Fonts */}
      <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet" />

      {/* NAV */}
      <nav style={styles.nav}>
        <div style={styles.navLogo}>FenceQuote<span style={{color:'rgba(255,255,255,0.5)'}}>Pro</span></div>
        <a href="https://fence-estimator-saas.web.app/login" style={styles.navCta}>Start Free Trial →</a>
      </nav>

      {/* HERO */}
      <section style={styles.hero}>
        <div style={{position:'absolute',inset:0,backgroundImage:'repeating-linear-gradient(90deg,transparent,transparent 80px,rgba(200,232,106,0.03) 80px,rgba(200,232,106,0.03) 81px),repeating-linear-gradient(0deg,transparent,transparent 80px,rgba(200,232,106,0.03) 80px,rgba(200,232,106,0.03) 81px)'}}></div>

        <div style={{position:'relative',zIndex:2,maxWidth:'700px'}}>
          <div style={styles.heroBadge}>
            <span style={{width:'8px',height:'8px',background:'#c8e86a',borderRadius:'50%',display:'inline-block'}}></span>
            🚀 Now with Customer-Facing Estimates
          </div>
          <h1 style={styles.h1}>
            Close More
            <span style={styles.accent}>Fence Jobs.</span>
            Faster.
          </h1>
          <p style={styles.heroSub}>
            Give your customers instant, professional fence estimates while keeping your pricing private. Built exclusively for fence contractors.
          </p>
          <div>
            <a href="https://fence-estimator-saas.web.app/login" style={styles.btnPrimary}>Start 14-Day Free Trial →</a>
            <a href="#how-it-works" style={styles.btnSecondary}>See How It Works</a>
          </div>
        </div>

        <div style={styles.heroStats}>
          {[{n:'14',l:'Day Free Trial'},{n:'2min',l:'To First Estimate'},{n:'$0',l:'Setup Fee'}].map((s,i)=>(
            <div key={i} style={styles.statCard}>
              <div style={styles.statNumber}>{s.n}</div>
              <div style={styles.statLabel}>{s.l}</div>
            </div>
          ))}
        </div>

        <div ref={fenceRef} style={styles.fenceGraphic}></div>
      </section>

      {/* LOGOS */}
      <div style={{background:'white',padding:'30px 60px',textAlign:'center',borderBottom:'1px solid rgba(0,0,0,0.06)'}}>
        <p style={{fontSize:'13px',color:'#999',textTransform:'uppercase',letterSpacing:'2px',marginBottom:'20px'}}>Trusted by fence contractors across the country</p>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'50px',flexWrap:'wrap'}}>
          {['PREMIER FENCE CO.','SOLID LINE FENCING','BORDER PRO','ELITE FENCE GROUP','CROWN FENCING'].map((n,i)=>(
            <span key={i} style={{fontFamily:'"Bebas Neue",sans-serif',fontSize:'22px',color:'#ccc',letterSpacing:'2px'}}>{n}</span>
          ))}
        </div>
      </div>

      {/* PROBLEM */}
      <div style={{background:'#f5f0e8'}}>
        <div style={styles.section}>
          <div style={styles.sectionLabel}>The Problem</div>
          <h2 style={styles.sectionTitle}>Estimating Jobs the Old Way <em>Is Costing You Business</em></h2>
          <p style={{fontSize:'18px',color:'#666',maxWidth:'600px',lineHeight:1.7}}>Every hour spent manually calculating estimates is an hour not spent winning new customers.</p>
          <div style={styles.painGrid}>
            {[
              {icon:'⏰',title:'Hours Wasted on Estimates',text:'Driving to job sites just to measure and quote takes half your day. Meanwhile your competition is already closing the deal.'},
              {icon:'📋',title:'Inconsistent Pricing',text:'Pricing from memory or old spreadsheets leads to underquoting jobs or losing customers to lower bids you could have beat.'},
              {icon:'😤',title:'Customers Want Answers NOW',text:"Today's customers won't wait 3 days for a quote. They'll find someone who gives them a number on the spot."},
              {icon:'💸',title:'No Professional Presence',text:'Without a polished estimator on your website, you look like every other contractor. Standing out is impossible.'},
            ].map((c,i)=>(
              <div key={i} style={styles.painCard}>
                <div style={{fontSize:'32px',marginBottom:'12px'}}>{c.icon}</div>
                <h3 style={{fontSize:'18px',fontWeight:600,marginBottom:'8px',color:'#1a3a2a'}}>{c.title}</h3>
                <p style={{fontSize:'15px',color:'#666',lineHeight:1.6}}>{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SOLUTION */}
      <div style={{background:'#1a3a2a',padding:'100px 60px'}}>
        <div style={{maxWidth:'1200px',margin:'0 auto',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'80px',alignItems:'center'}}>
          <div>
            <div style={{...styles.sectionLabel,color:'#c8e86a'}}>The Solution</div>
            <h2 style={{...styles.sectionTitle,color:'white'}}>Your Own Professional Fence Estimator — Up in Minutes</h2>
            <p style={{color:'rgba(255,255,255,0.65)',fontSize:'17px',lineHeight:1.7,marginBottom:'30px'}}>
              FenceQuote Pro gives you a branded customer estimator you can put on your website today. Customers get instant quotes. You keep your pricing private.
            </p>
            <ul style={{listStyle:'none',display:'flex',flexDirection:'column',gap:'16px'}}>
              {['Upload your fence styles with photos and pricing','Customers select, measure, and get an instant quote','Your profit margins are completely hidden','Automatic regional pricing by ZIP code','Property photo visualization tool','Customer contact form captures leads automatically'].map((item,i)=>(
                <li key={i} style={{display:'flex',alignItems:'flex-start',gap:'14px',color:'rgba(255,255,255,0.8)',fontSize:'16px',lineHeight:1.5}}>
                  <span style={{background:'#c8e86a',color:'#1a3a2a',width:'24px',height:'24px',borderRadius:'50%',display:'inline-flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'13px',flexShrink:0,marginTop:'2px'}}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div style={{background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'20px',padding:'30px'}}>
            <div style={{background:'rgba(255,255,255,0.1)',borderRadius:'10px',padding:'15px 20px',marginBottom:'20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <span style={{fontFamily:'"Bebas Neue",sans-serif',fontSize:'20px',color:'#c8e86a',letterSpacing:'1px'}}>Premier Fence Co.</span>
              <span style={{background:'#c8e86a',color:'#1a3a2a',padding:'4px 10px',borderRadius:'100px',fontSize:'11px',fontWeight:700}}>LIVE</span>
            </div>
            <p style={{fontSize:'13px',color:'rgba(255,255,255,0.5)',marginBottom:'14px'}}>Choose Your Fence Style:</p>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'20px'}}>
              <div style={{background:'rgba(255,255,255,0.08)',borderRadius:'8px',padding:'14px',border:'1.5px solid rgba(200,232,106,0.5)'}}>
                <div style={{width:'100%',height:'60px',background:'linear-gradient(135deg,#8B5E3C,#c08040)',borderRadius:'6px',marginBottom:'8px'}}></div>
                <p style={{fontSize:'12px',fontWeight:600,color:'white',margin:'2px 0'}}>Cedar Privacy</p>
                <p style={{fontSize:'11px',color:'#c8e86a',margin:'2px 0'}}>✓ Selected</p>
              </div>
              <div style={{background:'rgba(255,255,255,0.08)',borderRadius:'8px',padding:'14px',border:'1px solid rgba(255,255,255,0.1)'}}>
                <div style={{width:'100%',height:'60px',background:'linear-gradient(135deg,#aaa,#ddd)',borderRadius:'6px',marginBottom:'8px'}}></div>
                <p style={{fontSize:'12px',fontWeight:600,color:'white',margin:'2px 0'}}>White Vinyl</p>
                <p style={{fontSize:'11px',color:'rgba(255,255,255,0.5)',margin:'2px 0'}}>Privacy Panel</p>
              </div>
            </div>
            <div style={{background:'#c8e86a',borderRadius:'10px',padding:'20px',textAlign:'center'}}>
              <p style={{fontSize:'13px',color:'#1a3a2a',fontWeight:500}}>Your Estimated Total</p>
              <p style={{fontFamily:'"Bebas Neue",sans-serif',fontSize:'42px',color:'#1a3a2a',lineHeight:1,margin:'4px 0'}}>$3,847</p>
              <p style={{fontSize:'13px',color:'rgba(26,58,42,0.7)'}}>150 linear feet · 6ft height · ZIP 30301</p>
            </div>
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div style={{background:'white',padding:'100px 60px'}} id="how-it-works">
        <div style={{maxWidth:'1100px',margin:'0 auto',textAlign:'center'}}>
          <div style={styles.sectionLabel}>How It Works</div>
          <h2 style={styles.sectionTitle}>From Signup to <em>First Estimate</em> in Under 10 Minutes</h2>
          <div style={styles.stepsGrid}>
            {[
              {n:'1',title:'Create Your Account',text:'Sign up in seconds. Enter your company name and start your 14-day free trial. No credit card required.'},
              {n:'2',title:'Upload Your Fences',text:'Add your fence styles, photos, and base pricing. Bulk import via CSV if you have lots of products.'},
              {n:'3',title:'Share Your Link',text:'Get your unique customer estimator link. Put it on your website, email it to leads, or share on social media.'},
            ].map((s,i)=>(
              <div key={i} style={{padding:'0 20px'}}>
                <div style={styles.stepNumber}>{s.n}</div>
                <h3 style={{fontSize:'20px',fontWeight:600,color:'#1a3a2a',marginBottom:'12px'}}>{s.title}</h3>
                <p style={{fontSize:'15px',color:'#666',lineHeight:1.7}}>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FEATURES */}
      <div style={{background:'#f5f0e8',padding:'100px 60px'}} id="features">
        <div style={{maxWidth:'1100px',margin:'0 auto',textAlign:'center'}}>
          <div style={styles.sectionLabel}>Everything You Need</div>
          <h2 style={styles.sectionTitle}>All Features Included. <em>Free to Try.</em></h2>
          <p style={{color:'#666',fontSize:'17px',maxWidth:'600px',margin:'0 auto 20px',lineHeight:1.7}}>
            Start your 14-day free trial today. No credit card required. Full access from day one.
          </p>
          <div style={styles.featureGrid}>
            {[
              {icon:'🏗️',title:'Fence Library',text:'Upload unlimited fence styles with photos and pricing. Add one at a time or bulk import via CSV.'},
              {icon:'🔗',title:'Customer Estimator Link',text:'Get a unique public link to share anywhere. No customer login needed — just click and quote.'},
              {icon:'🔒',title:'Private Pricing Controls',text:'Set your labor %, profit margin, and markup privately. Customers only see the final total.'},
              {icon:'📍',title:'Regional ZIP Code Pricing',text:'Estimates automatically adjust for regional cost differences based on your customer\'s ZIP code.'},
              {icon:'🏠',title:'Property Visualization',text:'Customers upload a photo of their property and see your fence styles overlaid on their actual yard.'},
              {icon:'📋',title:'Lead Capture Form',text:'Customers submit their name, phone, and email after getting their quote — warm leads delivered to you.'},
            ].map((f,i)=>(
              <div key={i} style={styles.featureCard}>
                <div style={{fontSize:'32px',marginBottom:'12px'}}>{f.icon}</div>
                <h3 style={{fontSize:'18px',fontWeight:700,color:'#1a3a2a',marginBottom:'8px'}}>{f.title}</h3>
                <p style={{fontSize:'14px',color:'#666',lineHeight:1.7}}>{f.text}</p>
              </div>
            ))}
          </div>
          <div style={{marginTop:'50px',padding:'40px',background:'#1a3a2a',borderRadius:'16px',textAlign:'center'}}>
            <h3 style={{fontFamily:'"Bebas Neue",sans-serif',fontSize:'36px',color:'#c8e86a',letterSpacing:'1px',marginBottom:'10px'}}>Ready to See It in Action?</h3>
            <p style={{color:'rgba(255,255,255,0.7)',fontSize:'16px',marginBottom:'24px'}}>Start your free 14-day trial. All features included. No credit card required.</p>
            <a href="https://fence-estimator-saas.web.app/login" style={{display:'inline-block',background:'#c8e86a',color:'#1a3a2a',padding:'18px 45px',borderRadius:'6px',fontWeight:700,fontSize:'17px',textDecoration:'none'}}>Start Free Trial →</a>
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div style={styles.testimonialsSection}>
        <div style={{maxWidth:'1100px',margin:'0 auto',textAlign:'center'}}>
          <div style={{...styles.sectionLabel,color:'#c8e86a'}}>What Contractors Say</div>
          <h2 style={{...styles.sectionTitle,color:'white'}}>Real Results from Real Fence Companies</h2>
          <div style={styles.testimonialGrid}>
            {[
              {initials:'JR',name:'James R.',company:'Premier Fence Solutions, Atlanta GA',text:'"We put the link on our website and started getting quote requests overnight. Customers love being able to get an estimate without waiting for a callback."'},
              {initials:'MT',name:'Mike T.',company:'Solid Line Fencing, Denver CO',text:'"I was spending 2-3 hours a day on estimates. Now I spend 20 minutes. The pricing calculator handles everything and customers get instant answers."'},
              {initials:'SL',name:'Sarah L.',company:'Border Pro Fencing, Phoenix AZ',text:'"The fact that customers can\'t see my markup is huge. They just see the final price and a professional interface. We look like a much bigger company now."'},
            ].map((t,i)=>(
              <div key={i} style={styles.testimonialCard}>
                <div style={{color:'#c8e86a',fontSize:'18px',letterSpacing:'2px',marginBottom:'16px'}}>★★★★★</div>
                <p style={{fontSize:'16px',color:'rgba(255,255,255,0.8)',lineHeight:1.7,fontStyle:'italic',marginBottom:'20px'}}>{t.text}</p>
                <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
                  <div style={{width:'44px',height:'44px',borderRadius:'50%',background:'#4a7c59',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'"Bebas Neue",sans-serif',fontSize:'20px',color:'white'}}>{t.initials}</div>
                  <div>
                    <div style={{fontWeight:600,color:'white',fontSize:'15px'}}>{t.name}</div>
                    <div style={{fontSize:'13px',color:'rgba(255,255,255,0.5)'}}>{t.company}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div style={styles.faqSection}>
        <div style={{maxWidth:'800px',margin:'0 auto',textAlign:'center'}}>
          <div style={styles.sectionLabel}>FAQ</div>
          <h2 style={styles.sectionTitle}>Common Questions</h2>
          <div style={{marginTop:'50px',textAlign:'left'}}>
            {[
              {q:'Do my customers need to create an account?',a:'No. Customers click your link and get an instant estimate with zero signup required. No friction, no barriers.'},
              {q:'Can customers see my profit margins or markup?',a:'Absolutely not. Your pricing settings are completely private. Customers only see the final total and a per-foot price.'},
              {q:'How accurate are the estimates?',a:"Estimates are based on your actual pricing, adjusted for fence height and regional ZIP code differences. They're designed to start the conversation, with a note that final pricing is confirmed on-site."},
              {q:'Can I import my existing fence catalog?',a:'Yes! Use our bulk CSV import to upload your entire fence catalog in minutes.'},
              {q:'Do I need a website to use this?',a:'No website needed. You get a shareable link you can send via email, text, or post on social media.'},
              {q:'What happens after my free trial?',a:"We'll reach out personally to discuss the best plan for your business. No surprise charges — everything is confirmed with you directly."},
            ].map((f,i)=>(
              <div key={i} style={styles.faqItem}>
                <div style={{fontSize:'18px',fontWeight:600,color:'#1a3a2a',marginBottom:'10px'}}>{f.q}</div>
                <div style={{fontSize:'16px',color:'#666',lineHeight:1.7}}>{f.a}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FINAL CTA */}
      <div style={styles.finalCta}>
        <h2 style={{fontFamily:'"Bebas Neue",sans-serif',fontSize:'clamp(48px,6vw,80px)',color:'#1a3a2a',lineHeight:1,marginBottom:'20px'}}>Ready to Win More Fence Jobs?</h2>
        <p style={{fontSize:'20px',color:'rgba(26,58,42,0.7)',marginBottom:'40px'}}>Start your free 14-day trial. No credit card required.</p>
        <a href="https://fence-estimator-saas.web.app/login" style={{display:'inline-block',background:'#1a3a2a',color:'#c8e86a',padding:'20px 50px',borderRadius:'4px',fontWeight:700,fontSize:'18px',textDecoration:'none'}}>Start Free Trial Now →</a>
      </div>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <div style={{fontFamily:'"Bebas Neue",sans-serif',fontSize:'24px',color:'#c8e86a',letterSpacing:'2px'}}>FenceQuote<span style={{color:'rgba(255,255,255,0.3)'}}>Pro</span></div>
        <div style={{display:'flex',gap:'30px'}}>
          {[['#features','Features'],['#how-it-works','How It Works'],['mailto:contact@simplyawesomemarketing.com','Contact']].map(([href,label],i)=>(
            <a key={i} href={href} style={{color:'rgba(255,255,255,0.5)',textDecoration:'none',fontSize:'14px'}}>{label}</a>
          ))}
        </div>
        <div style={{color:'rgba(255,255,255,0.3)',fontSize:'13px',width:'100%',textAlign:'center',paddingTop:'20px',borderTop:'1px solid rgba(255,255,255,0.07)',marginTop:'10px'}}>
          © 2026 FenceQuote Pro by Simply Awesome Marketing · All rights reserved
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;